import React from "react";
import { cn } from "../lib/utils";

export default function StatsCard({ label, value, icon: Icon, accent = "ink", footer, testid }) {
  const accentClass = {
    ink: "text-ink-900",
    brand: "text-brand",
    emerald: "text-emerald-600",
    rose: "text-rose-600",
    amber: "text-amber-600",
  }[accent] || "text-ink-900";

  return (
    <div
      data-testid={testid}
      className={cn(
        "rounded-xl border border-ink-100 bg-white p-6 shadow-sm card-hover",
      )}
    >
      <div className="flex items-center justify-between">
        <p className="label-caps">{label}</p>
        {Icon ? <Icon className={cn("h-5 w-5", accentClass)} /> : null}
      </div>
      <p className={cn("mt-3 font-heading text-3xl font-bold tracking-tight", accentClass)}>{value}</p>
      {footer ? <p className="mt-2 text-sm text-ink-500">{footer}</p> : null}
    </div>
  );
}
